module.exports = __webpack_public_path__ + "img/69.43c120f2.webp";